import i18next from 'i18next';
import { initReactI18next, useTranslation } from 'react-i18next';
import { catalogs, resolveLocale, type AppLocale } from '@vwt/i18n';

const STORAGE_KEY = 'vwt.locale';

function initialLocale(): AppLocale {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved) return resolveLocale(saved);
  } catch {
    // storage unavailable
  }
  return resolveLocale(navigator.language);
}

void i18next.use(initReactI18next).init({
  resources: {
    en: { translation: catalogs.en },
    'pt-BR': { translation: catalogs['pt-BR'] },
    es: { translation: catalogs.es },
  },
  lng: initialLocale(),
  fallbackLng: 'en',
  supportedLngs: ['en', 'pt-BR', 'es'],
  interpolation: { escapeValue: false },
  returnNull: false,
});

/** The profile preference overrides browser detection (Section 1.1). */
export function applyLocale(locale: string) {
  const resolved = resolveLocale(locale);
  try {
    localStorage.setItem(STORAGE_KEY, resolved);
  } catch {
    // ignore
  }
  document.documentElement.lang = resolved;
  if (i18next.language !== resolved) void i18next.changeLanguage(resolved);
}

export const currentLocale = (): AppLocale => resolveLocale(i18next.language);
export { useTranslation };
export default i18next;
